import { RESET_SCOPING_METHODS } from '../constants/scoping_methods';

export const resetScopingMethod = () => ({
  type: RESET_SCOPING_METHODS,
});
